// extracted by mini-css-extract-plugin
export default {"root":"Money-module__root___MTGNi","label":"Money-module__label___EngdX"};